import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import ContractRow from './ContractRow';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 11px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--text-primary);
`;

const MyCommunitySection = () => {
  const { community } = useCommunityViewContext();

  if (!community?.id) {
    return null;
  }

  return (
    <Container>
      <Title>My Community</Title>
      <ContractRow
        communityId={community.id}
        name={community.comunity_name}
        color="var(--text-primary)"
        contracts={community.contracts || []}
      />
    </Container>
  );
};

export default MyCommunitySection;
